import { withServerErrorCode } from '@plone/volto/helpers/Utils/Utils';
import { Redirect } from 'react-router-dom';

const Unauthorized = () => {
  return <Redirect to="/login-code" />;
};

export default withServerErrorCode(401)(Unauthorized);
